import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DaterangeService {

    $selectedRange = new BehaviorSubject<number>(7);
    $selectedRangeSystemHealth = new BehaviorSubject<number>(7);
    $selectedRangeServiceHistory = new BehaviorSubject<number>(30);
    $selectedRangeServiceMetrics = new BehaviorSubject<number>(7);
    $selectedRangeFunctionLocation = new BehaviorSubject<number>(7);
    $selectedRangeUpcomingServices = new BehaviorSubject<number>(7);
    $selectedRangeBookmark = new BehaviorSubject<number>(7);
    $selectedRangeFunctionLocationSite = new BehaviorSubject<number>(7);
    $selectedRangeUpcomingServicesSite = new BehaviorSubject<number>(7);

changeRange(range: number, type: 'systemHealth' | 'serviceHistory' | 'funcloc' | 'upcomingServices' | 'bookmark') {
        if (type === 'systemHealth') {
            console.log("Changing system health range to:", range); 
            this.$selectedRangeSystemHealth.next(range);
        } else if (type === 'serviceHistory') {
            console.log("Changing system health range to:", range); 
            this.$selectedRangeServiceHistory.next(range);
        } else if (type === 'funcloc') {
            console.log("Changing system health range to:", range); 
            this.$selectedRangeFunctionLocation.next(range);
        } else if (type === 'upcomingServices') {
            console.log("Changing upcoming services range to:", range); 
            this.$selectedRangeUpcomingServices.next(range);
        } else if (type === 'bookmark') {
            console.log("Changing bookmark range to:", range); 
            this.$selectedRangeBookmark.next(range);
        }
    }

    constructor() { }

}